import { isEmpty } from 'lodash';

import styled from '@emotion/styled';

import { ProductData } from '../../../../shared/interfaces';

import ListSwiper from '../list/ListSwiper';

import { productListSlidePerView } from '../constant';
import MainProductCard from './MainProductCard';
import applyImageUrlFormat
  from '../../../../shared/utils/image/imaegUrlformatter';
import { ProductMainSelectData } from '../../../../shared/interfaces/Product';

const ProductCard = styled(MainProductCard)`
  width: 249px;
  .image-container {
    height: 320px;
  }
`;

interface Props {
  products: ProductData[];
  landingUrl?: string;
  selectProduct(selectProduct: ProductMainSelectData): void;
  selectMore(): void;
}

export default function ProductListSection({ products, landingUrl, selectProduct, selectMore }: Props ) {
  if (isEmpty(products)) {
    return null;
  }

  const items = products.map((product, index) => (
    <ProductCard
      key={product.no}
      index={index}
      selectProduct={selectProduct}
      product={{
        ...product,
        listImageUrl: applyImageUrlFormat(product.listImageUrl,
          {
            width: 400,
            format: 'auto',
          }),
      }}
    />
  ));

  return (
    <ListSwiper
      items={items}
      slidesPerView={productListSlidePerView}
      slideAsGroup
      landingUrl={landingUrl}
      hadleSelectMore={selectMore}
    />
  );
}
